/**
 * Every public page and panel partial embeds the GeoJSON its map shows in a
 * `<script type="application/json" id="page-geojson">`; there is no endpoint.
 */

/** The GeoJSON a page or partial embeds, null when the script is absent or malformed. */
export function readPageGeoJson(source: Pick<ParentNode, 'querySelector'>): PageGeoJson | null {
  const script = source.querySelector('#page-geojson');
  if (!script) return null;
  try {
    return JSON.parse(script.textContent || '') as PageGeoJson;
  } catch (e) {
    console.error('Error parsing page GeoJSON:', e);
    return null;
  }
}
